import { FETCH_CONVERSATIONS_BEGIN, FETCH_CONVERSATIONS_FAILED, FETCH_CONVERSATIONS_SUCCESS } from "../actions/conversations/fetchConversations"
import { FETCH_MORE_CONVERSATIONS_BEGIN, 
         FETCH_MORE_CONVERSATIONS_FAILED,
         FETCH_MORE_CONVERSATIONS_SUCCESS,
         REACHED_END_OF_CONVERSATIONS } from "../actions/conversations/fetchMoreConversations"
import { MARK_CURRENT_CONVERSATION_AS_READ_SUCCESS } from "../actions/currentConversation/markCurrentConversationAsRead"

const initialState = {
  loading: true,
  conversations: [],
  loadingMoreConversations: false,
  canLoadMoreConversations: true
}

export function conversations(state=initialState, { type, payload }) {
  switch(type){
    case MARK_CURRENT_CONVERSATION_AS_READ_SUCCESS:
      let index = state.conversations.findIndex(conversation=> conversation.id == payload.id)
      state.conversations[index].unread_count = 0
      return state
    case FETCH_CONVERSATIONS_BEGIN:
      return { ...state, ...payload }
    case FETCH_CONVERSATIONS_SUCCESS:
      return { ...state, loading: false, conversations: payload,
         loadingMoreConversations: false, canLoadMoreConversations: true }
    case FETCH_CONVERSATIONS_FAILED:
      return { ...state, loading: false }
    case FETCH_MORE_CONVERSATIONS_BEGIN:
      return { ...state, loadingMoreConversations: true }
    case FETCH_MORE_CONVERSATIONS_FAILED:
      return { ...state, loadingMoreConversations: false }
    case REACHED_END_OF_CONVERSATIONS:
      return { ...state, loadingMoreConversations: false, canLoadMoreConversations: false }
    case FETCH_MORE_CONVERSATIONS_SUCCESS:
      return { ...state, conversations: [...state.conversations,...payload],
           loadingMoreConversations: false }
    default:
      return state
  }
}